import { render, staticRenderFns } from "./DashboardFranchiseeComparisons.vue?vue&type=template&id=3c5ca41e&scoped=true&"
import script from "./DashboardFranchiseeComparisons.vue?vue&type=script&lang=js&"
export * from "./DashboardFranchiseeComparisons.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFranchiseeComparisons.vue?vue&type=style&index=0&id=3c5ca41e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ca41e",
  null
  
)

export default component.exports